import React, { useEffect, useState } from "react";
import "./PaymentMethodsBody.scss";
import { useStore } from "../../../hooks/store";
import { AgroIcon, Text } from "agrofy-ui-components";
import PaymentMethodItem from "../../../atoms/AgrofyPay/PaymentMethodItem/PaymentMethodItem";

const PaymentMethodsBody = (props) => {
  const [state, dispatch] = useStore();
  const [paymentMethodType, setPaymentMethodType] = useState(null);
  const [paymentMethodCategory, setPaymentMethodCategory] = useState(null);

  useEffect(() => {
    if (state.selectedPaymentMethodType) {
      setPaymentMethodType(state.selectedPaymentMethodType);
    }
  }, [state.selectedPaymentMethodType]);

  useEffect(() => {
    if (state.selectedPaymentCategory) {
      setPaymentMethodCategory(state.selectedPaymentCategory);
    }
  }, [state.selectedPaymentCategory]);

  const navigateBack = () => {
    dispatch("SET_SELECTED_PAYMENT_METHOD", null);
  };

  const mobileHeading = (
    <div className="navigationHeader d-mobile">
      <a onClick={navigateBack}>
        <AgroIcon iname="navigateLeft" width="20" height="20"></AgroIcon>
      </a>
    </div>
  );

  return (
    <>
      {mobileHeading}
      <div>
        {paymentMethodCategory ? (
          <>
            {!!paymentMethodCategory.Image ? (
              <div className="iconContainer">
                <img className="logoHeader" src={paymentMethodCategory.Image} />
              </div>
            ) : null}

            <Text
              color="gray8"
              className={["heading-sm", "title"].join(" ")}
              type="heading-xs"
            >
              {paymentMethodCategory.Description}
            </Text>
          </>
        ) : null}

        <div>
          {paymentMethodType ? (
            <div className="infoContainer">
              <div>
                <Text className="heading-md" type="heading-sm" color="gray9" tag="h2" ma="0">
                  {paymentMethodType.Name}
                </Text>
              </div>
              {paymentMethodType.Description ? (
                <div className="subtitleContainer">
                  <Text type="body-lg" color="gray9">
                    {paymentMethodType.Description}
                  </Text>
                </div>
              ) : null}

              <div className="paymentItemsContainer">
                {paymentMethodType.PaymentMethods.map((item, index) => {
                  return (
                    <PaymentMethodItem
                      key={`${item.Id}-${index}`}
                      item={item}
                      isLast={
                        paymentMethodType.PaymentMethods.length - 1 === index
                      }
                    ></PaymentMethodItem>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default PaymentMethodsBody;
